/**
 * Historia 176 — CU2/CU3. The class of an i18n key, as fixed by `03-dominio.md` §6 "Clase de una
 * clave" (I9, RN22, RN24): a pure function over facts the caller already knows, never a lookup of
 * its own.
 *
 * - `label` — the key is in the build-time catalogue (RN3): it can be redefined with free text.
 * - `detached` — not in the catalogue, not in `en.json`, not among the literal keys the build found
 *   anywhere in the source (RN22): nothing in this version's code can resolve it any more; only its
 *   own history explains why it is there.
 * - `outsideCatalogue` — the rest: not a label, but still traceable to `en.json` or to a literal use
 *   (a text built from data may still reach it, T16).
 *
 * @param {string} key The i18n key (unused by the classification itself, kept for call-site clarity
 *   and so callers do not have to destructure just to log which key was classified)
 * - `systemValue` — story 204 (RN6.3): the key is a code of Sun's system-value catalogue (C5). It wins over the
 *   three above: a status code that is also a label or sits in `en.json` is edited as a system value.
 *
 * @param {{isSystemValue?: boolean, isLabel?: boolean, inEnJson?: boolean, inUsedKeys?: boolean}} facts What the caller
 *   already knows about this key
 * @returns {'systemValue'|'label'|'outsideCatalogue'|'detached'} The class
 */
export const classify = (key, { isSystemValue = false, isLabel = false, inEnJson = false, inUsedKeys = false } = {}) => {
  if (isSystemValue) return 'systemValue'
  if (isLabel) return 'label'
  if (!inEnJson && !inUsedKeys) return 'detached'
  return 'outsideCatalogue'
}
